// src/components/navbar-top/BurgerMenuToggle.jsx

import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Navbar } from 'react-bootstrap';

import { navbarBreakPoint } from 'config';

const BurgerMenuToggle = ({ navbarPosition, handleBurgerMenu }) => {
  	const burgerMenuRef = useRef();
  	
	return (
		<Navbar.Toggle
	  		ref={burgerMenuRef}
	  		className={classNames('toggle-icon-wrapper me-md-3 me-2', {
				'd-lg-none': navbarPosition === 'top' || navbarPosition === 'double-top',
				[`d-${navbarBreakPoint}-none`]: navbarPosition === 'vertical' || navbarPosition === 'combo',
	  		})}
	  		as="div" >
	  		<button className="navbar-toggler-humburger-icon btn btn-link d-flex flex-center" onClick={handleBurgerMenu} id="burgerMenu">
				<span className="navbar-toggle-icon">
		  			<span className="toggle-line" />
				</span>
	  		</button>
		</Navbar.Toggle>
  	);
};

BurgerMenuToggle.propTypes = {
	navbarPosition: PropTypes.string,
	handleBurgerMenu: PropTypes.func,
};

export default BurgerMenuToggle;